"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payload = void 0;
var Payload = /** @class */ (function () {
    function Payload(data) {
        this.properties = data || {};
    }
    Payload.prototype.add = function (property, value) {
        this.properties[property] = value;
    };
    Payload.prototype.getProperties = function () {
        return this.properties;
    };
    Payload.fromJSON = function (data) {
        return new Payload(data);
    };
    Payload.prototype.merge = function (source) {
        if (!source)
            return new Payload(__assign({}, this.getProperties()));
        return new Payload(__assign(__assign({}, source.getProperties()), this.getProperties()));
    };
    Payload.prototype.toSendable = function () {
        return JSON.stringify(this.properties);
    };
    return Payload;
}());
exports.Payload = Payload;
